export default __webpack_public_path__ + "static/media/css.df72f602.png";